import debounce from 'lodash/debounce';


export const debounceEventHandler = (...args) => {
    const debounced = debounce(...args)
    return function (e, ...args) {
        e.persist()
        return debounced(e, ...args)
    }
}




export const isLocationRemote = (location) => {
    var locationBase = (location || "").toLowerCase();

    var locationStripped = locationBase.toLowerCase()
        .replace("remote", "")
        .replace("telecomute", "")
        .replace("telecommute", "")
        .replace("remotework", "")
        .replace("remote work", "");

    return locationStripped !== locationBase;
}




export class Geocoder {

    static get(address) {
        const geocoder = new google.maps.Geocoder();

        return new Promise((resolve, reject) => {
            geocoder.geocode({ 'address': address }, function (results, status) {
                if (status != google.maps.GeocoderStatus.OK) {
                    reject();
                } else {
                    const geometry = results[0].geometry;

                    let ne, sw;
                    if (geometry.bounds) {
                        ne = geometry.bounds.getNorthEast();
                        sw = geometry.bounds.getSouthWest();
                    } else {
                        ne = geometry.viewport.getNorthEast();
                        sw = geometry.viewport.getSouthWest();
                    }

                    var GLOBE_WIDTH = 256; // a constant in Google's map projection
                    var west = sw.lng();
                    var east = ne.lng();
                    var angle = east - west;
                    if (angle < 0) {
                        angle += 360;
                    }
                    var zoom = Math.round(
                        Math.log(600 * 360 / angle / GLOBE_WIDTH) / Math.LN2);

                    resolve({
                        center: {
                            lat: geometry.location.lat(),
                            lng: geometry.location.lng()
                        },
                        zoom
                    });
                }
            });
        });
    }
}



export class Storage {

    static isSupported() {
        try {
            if (window.localStorage) {
                return true;
            }
        } catch (e) { /* localStorage not available */ }
        return false;
    }

    static fallBack = {};

    static setItem(key, value) {
        if(!Storage.isSupported()) {
            this.fallBack[key] = value;
        } else {
            window.localStorage.setItem(key, value);
        }
    }

    static setObject(key, value) {
        if(!Storage.isSupported()) {
            this.fallBack[key] = value;
        } else {
            window.localStorage.setItem(key, JSON.stringify(value));
        }
    }

    static getItem(key) {
        if(!Storage.isSupported()) {
            return this.fallBack[key];
        }

        return window.localStorage.getItem(key);
    }

    static getObject(key) {
        if(!Storage.isSupported()) {
            return this.fallBack[key];
        }
        const value = window.localStorage.getItem(key);
        return value && JSON.parse(value);
    };

    static removeItem(key) {
        if(!Storage.isSupported()) {
            delete this.fallBack[key];
        } else {
            window.localStorage.removeItem(key);
        }
    }
}